import { Button } from 'components/ui';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSidebar } from 'contexts/SidebarContext';

interface NewChatButtonProps {
  isCollapsed?: boolean;
}

export const NewChatButton: React.FC<NewChatButtonProps> = ({ isCollapsed = false }) => {
  const { isMobile, setMobileOpen } = useSidebar();

  if (isCollapsed) {
    return null; // Don't show new chat button when collapsed
  }

  const handleNewChat = () => {
    if (isMobile) setMobileOpen(false);
    // Focus on input after new chat is initiated
    setTimeout(() => {
      const textarea = document.querySelector('textarea[placeholder="Describe what you need..."]');
      if (textarea) {
        (textarea as HTMLTextAreaElement).focus();
      }
    }, 100);
  };

  return (
    <NavLink
      to="/dashboard/assistant"
      onClick={handleNewChat}
      className="flex items-center justify-center w-full py-3 px-0 mb-4 transition-all"
    >
      <Button
        type="button"
        size="sm"
        className="font-medium flex justify-center gap-2 items-center"
        variant="primary"
      >
        <span className="text-center mb-[1px]">+</span>
        <span className="text-center">New Chat</span>
      </Button>
    </NavLink>
  );
};
